export default class Modal {
	constructor() {
		this.modalButtons = document.querySelectorAll('[data-open=contact]');
		this.contactModal = document.querySelector('[data-modal=contact]');
		this.closeButton = document.querySelector('[data-close=contact]');
		this.firstInput = document.querySelector('[data-modal=contact] input');

		this.modalButtons.forEach(button => {
			button.addEventListener('click', () => {
				this.openModal(true);
			});
		});

		this.contactModal.addEventListener('click', e => {
			if (e.target.dataset.modal) {
				this.closeModal(true);
			}
		});

		this.closeButton.addEventListener('click', () => {
			this.closeModal(true);
		});

		this.checkHash();

		window.addEventListener('popstate', this.checkHash.bind(this));
		this.contactModal.addEventListener('keydown', e => {
			if (e.key === 'Escape' || e.key === 'Esc') {
				this.closeModal(true);
			}
		});
	}

	openModal(push = false) {
		this.contactModal.classList.add('active');
		this.firstInput.focus();

		if (push) {
			window.history.pushState({}, document.title, '#sales');
		}
	}

	closeModal(push = false) {
		this.contactModal.classList.remove('active');

		if (push) {
			window.history.pushState({}, document.title, window.location.pathname);
		}
	}

	checkHash() {
		if (window.location.hash === '#sales') {
			this.openModal();
		} else {
			this.closeModal();
		}
	}
}
